/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorDataModel } from '../../models/patient-behavior-data-model';

export interface GetBehaviorRawData$Params {
  patientBehaviorID?: number;
  startDate?: string;
  endDate?: string;
}

export function GetBehaviorRawData(http: HttpClient, rootUrl: string, params?: GetBehaviorRawData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorDataModel>>> {
  const rb = new RequestBuilder(rootUrl, GetBehaviorRawData.PATH, 'get');
  if (params) {
    rb.query('patientBehaviorID', params.patientBehaviorID, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientBehaviorDataModel>>;
    })
  );
}

GetBehaviorRawData.PATH = '/api/Supervisor/GetBehaviorRawData';
